<template>
  <div class="elite-tabs-wrapper-content">
    <div class="row mb-4">
      <div class="col-12">
        <h3 class="display-4 col-12">{{ $t("COMMON.DETAILS") }}</h3>
      </div>
    </div>

    <stock-movement-view-details-product-list
      :stockMovement="stockMovement"
      @stockMovementItemsUpdated="stockMovementItemsUpdated"
    />
  </div>
</template>

<script>
import { Button, Tooltip } from "element-ui";
import StockMovementViewDetailsProductList from "./StockMovementViewDetailsProductList.vue";

export default {
  name: "stock-movement-view-details",

  components: {
    StockMovementViewDetailsProductList,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
  },

  mixins: [],

  props: ["stockMovement"],

  data() {
    return {};
  },

  computed: {},

  methods: {
    stockMovementItemsUpdated() {
      this.$emit("stockMovementItemsUpdated");
    },
  },

  mounted() {},

  watch: {},
};
</script>
